import loadScript from '../../js/utils/loadScript';

const YOUTUBE_SDK = 'https://www.youtube.com/player_api';

let promise = null;

const youtubePlayer = () => {
  if (promise) {
    return promise;
  }

  promise = new Promise((resolve) => {
    loadScript(YOUTUBE_SDK).then(() => {
      window.YT.ready(() => resolve(window.YT.Player));
    });
  });

  return promise;
};

export default youtubePlayer;
